import useTranslation from 'next-translate/useTranslation'

import ProductType from '@/ts/enums/product/ProductType'
import SectionHeading from '@/views/common/SectionHeading'
import INSTRUCTIONS from '@/views/product/data/instructions'
import { HowItWorksProps } from '@/views/product/ts'

import InstructionCard from './includes/InstructionCard'

function HowItWorks({ type }: HowItWorksProps) {
  const { t } = useTranslation('products')

  if (type !== FansiClass && type !== FansiVideo) return null

  const kind = type === FansiClass ? 'fansi_class' : 'fansi_video'
  const instructions = INSTRUCTIONS[kind]

  const heading = `${t(`global:${kind}`)} - ${t('how_it_works')}`

  return (
    <div className="mt-8 space-y-12 md:mt-12">
      <SectionHeading text={heading} />
      <div className="grid grid-cols-1 gap-12 px-4 md:grid-cols-2 lg:grid-cols-3">
        {instructions.map((instruction, index) => (
          <InstructionCard
            key={index}
            instruction={instruction}
            step={index + 1}
          />
        ))}
      </div>
    </div>
  )
}

const { FansiClass, FansiVideo } = ProductType

export default HowItWorks
